import { render, staticRenderFns } from "./UserInventory.vue?vue&type=template&id=d87d8986"
import script from "./UserInventory.js?vue&type=script&lang=js&external"
export * from "./UserInventory.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports